import { DeviceTypesEnum } from "../../enums/DeviceTypesEnum";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
import { DRCXAvailableObject } from "./DRCXAvailableObject";
import { IDRCXAvailableObjectsDTO } from "./DRCXAvailableObjectsDTO";

export class DRCXAvailableObjects {
    public groups: Array<DRCXAvailableObject>;
    public devices: Array<DRCXAvailableObject>;
    public tanks: Array<DRCXAvailableObject>;
    public wells: Array<DRCXAvailableObject>;
    public tankBatteries: Array<DRCXAvailableObject>;

    public constructor(dto: IDRCXAvailableObjectsDTO) {
        this.groups = dto.groups
            ? dto.groups.map(dto => {
                return new DRCXAvailableObject(dto.dt, dto.id, eLynxObjectTypeEnum.Group);
            })
            : new Array<DRCXAvailableObject>();
        this.devices = dto.devices
            ? dto.devices.map(dto => {
                return new DRCXAvailableObject(
                    dto.dt,
                    dto.id,
                    eLynxObjectTypeEnum.Device,
                    dto.ti as DeviceTypesEnum,
                    undefined,
                    dto.av);
            })
            : new Array<DRCXAvailableObject>();
        this.tanks = dto.tanks
            ? dto.tanks.map(dto => {
                return new DRCXAvailableObject(
                    dto.dt,
                    dto.id,
                    eLynxObjectTypeEnum.Tank,
                    dto.ti as DeviceTypesEnum,
                    undefined,
                    dto.av);
            })
            : new Array<DRCXAvailableObject>();
        this.wells = dto.wells
            ? dto.wells.map(dto => {
                return new DRCXAvailableObject(dto.dt, dto.id, eLynxObjectTypeEnum.Well, undefined, undefined, dto.av);
            })
            : new Array<DRCXAvailableObject>();

        this.tankBatteries = dto.tankBatteries
        ? dto.tankBatteries.map(dto => {
            return new DRCXAvailableObject(dto.dt, dto.id, eLynxObjectTypeEnum.TankBattery, undefined, undefined, dto.av);
        })
        : new Array<DRCXAvailableObject>();

    }
}
